import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { useSelector, useDispatch } from 'react-redux';
import { Typography, colors } from '@mui/material';
import ModalDialog from '../../../../../components/ModalDialog/ModalDialog.js';
import { AddIncidentConfiguration, ToggleIncConfigDialog, SetFormState, UpdateIncidentConfiguration, DeleteIncidentConfiguration } from '../../../actions/IncidentTrackerConfigurationActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 960,
	},
	header: {
		padding: theme.spacing(3),
		maxWidth: 720,
		margin: '0 auto',
	},
	content: {
		padding: theme.spacing(0, 2),
		maxWidth: 720,
		margin: '0 auto',
	},
	helperText: {
		textAlign: 'right',
		marginRight: 0,
	},
	author: {
		margin: theme.spacing(4, 0),
		display: 'flex',
	},
	avatar: {
		marginRight: theme.spacing(2),
	},
	actions: {
		backgroundColor: colors.grey[100],
		padding: theme.spacing(2),
		display: 'flex',
		alignContent: 'right',
	},
	applyButton: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const IncidentConfigurationDialog = (props) => {
	const { open, onClose, children, category, mode, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = (formState) => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.incidentTrackerReducer.formState);
	const selectedConfiguration = useSelector((state) => state.incidentTrackerConfigurationReducer.selectedConfiguration);

	const _onConfirmClick = () => {
		if (mode === 'Update') {
			dispatch(UpdateIncidentConfiguration({ ...selectedConfiguration.item, name: selectedConfiguration.category }));
		} else if (mode === 'Add') {
			dispatch(AddIncidentConfiguration({ ...selectedConfiguration.item, name: selectedConfiguration.category }));
		} else if (mode === 'Delete') {
			dispatch(DeleteIncidentConfiguration(selectedConfiguration.category, selectedConfiguration.item.id));
		}
		dispatch(ToggleIncConfigDialog(false, mode));
	};

	return (
		<ModalDialog
			maxWidth="xs"
			onClose={onClose}
			open={open}
			title={`${mode} ${category}`}
			isDisabled={mode !== 'Delete' && !formState.isValid}
			confirmLabel={mode}
			onConfirmClicked={_onConfirmClick}
		>
			{children}
			{mode === 'Delete' && (
				<Typography
					className={classes.author}
					variant="subtitle2"
					component="div"
					defaultValue={`Do you want to delete this ${category.toLowerCase()}?`}
				>
					{`Do you want to delete this ${category.toLowerCase()}?`}
				</Typography>
			)}
		</ModalDialog>
	);
};

IncidentConfigurationDialog.propTypes = {
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
	children: PropTypes.array,
	category: PropTypes.string,
	mode: PropTypes.string
};

export default IncidentConfigurationDialog;
